import { render, staticRenderFns } from "./ErrorsList.vue?vue&type=template&id=134f31d8&scoped=true&"
import script from "./ErrorsList.vue?vue&type=script&lang=js&"
export * from "./ErrorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f31d8",
  null
  
)

export default component.exports